"use client";

import Image from "next/image";
import { Grid, Card, Stack, Title, Text, AspectRatio, Box, Container, Paper } from "@mantine/core";
import classes from "./OutfitGrid.module.css";
import { useState } from "react";
import { firebaseLoader } from "@/lib/imageLoader";

interface OutfitIdea {
  title: string;
  description: string;
  imageData: string;
}

interface OutfitGridProps {
  outfitIdeas: OutfitIdea[];
}

export default function OutfitGrid({ outfitIdeas }: OutfitGridProps) {
  const [imageErrors, setImageErrors] = useState<{ [key: string]: boolean }>({});

  const handleImageError = (index: number) => {
    setImageErrors((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <Grid gutter={{ base: "md", md: "xl" }}>
      {outfitIdeas.map((outfit: OutfitIdea, index: number) => (
        <Grid.Col key={index} span={{ base: 12, sm: 6 }}>
          {/* <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.card}> */}
          <Stack gap="0" className={classes.cardContent}>
            {/* Text Content */}

            <Container size="xl" p="0" m="0" style={{ borderRadius: "1rem" }}>
              {!imageErrors[index] ? (
                <Image
                  priority
                  loader={firebaseLoader}
                  src={outfit.imageData}
                  layout="responsive"
                  height="500"
                  width="400"
                  alt={outfit.title}
                  style={{ borderRadius: "1rem" }}
                  onError={() => handleImageError(index)}
                  unoptimized // Skip Next.js image optimization for Firebase Storage URLs
                />
              ) : (
                <Box
                  style={{
                    borderRadius: "1rem",
                    backgroundColor: "#f8f9fa",
                    height: "500px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text c="dimmed" ta="center" p="md">
                    Image not available
                  </Text>
                </Box>
              )}
            </Container>
            <div>
              <Title order={3} size="h4" fw={600} mb="0">
                {outfit.title}
              </Title>
              <Text size="sm" c="dimmed">
                {outfit.description}
              </Text>
            </div>
          </Stack>
          {/* </Card> */}
        </Grid.Col>
      ))}
    </Grid>
  );
}
